<footer class="text-center">
    <div class="container">
        <!-- <div class="  getintouch">
            <h3 class="title text-center">{{footer_title}}</h3>
            <p class="text-center">{{footer_description}} </p>
        </div> -->
        <div class="row">

            <!-- <div class="col-lg-4 ftr-social offset-4">
                <div class="social ">
                    <a href="# "><i class="fab fa-facebook "></i>  </a>

                    <a href="# "><i class="fab fa-instagram " aria-hidden="true "></i>  </a>

                    <a href="# "><i class="fab fa-dribbble " aria-hidden="true "></i>  </a>
                </div>
            </div> -->
            <div class="col-lg-4 copyright p-2 ">

                <!-- <a href="./#/home "><img src="./assets/img/ros_logo.png " alt=" "></a> -->
                <p> © {{currentYear}} Rotating Offshore Solutions Pte Ltd.</p>
            </div>
        </div>

        <!-- <div class=" row ">

            <div class="col-lg-4 copyright hide ">

                <a href="#/home "><img src="./assets/img/ros_logo.png " alt=" "></a>
                <p>© 2019 Rotating Offshore Solutions Pte Ltd.</p>
            </div>
            <div class="col-lg-4 getintouch show ">
                <h3 class="title ">Get In Touch</h3>
                <p>109 Tuas South Ave 8, Singapore 637037</p>
                <p>contactus@ros.com.sg<br> +65 67788271</p>
                <p>hi@ros.com.sg</p>
            </div>
            <div class="col-lg-4 ftr-social ">
                <div class="social ">
                    <a href="# "><i class="fab fa-facebook "></i>  </a>
                    <a href="# "><i class="fab fa-twitter " aria-hidden="true "></i>  </a>
                    <a href="# "><i class="fab fa-instagram " aria-hidden="true "></i>  </a>
                    <a href="# "><i class="fab fa-behance " aria-hidden="true "></i>  </a>
                    <a href="# "><i class="fab fa-dribbble " aria-hidden="true "></i>  </a>
                </div>
            </div>
            <div class="col-lg-4 getintouch hide ">
                <h3 class="title ">Get In Touch</h3>
                <p>109 Tuas South Ave 8, Singapore 637037</p>
                <p>contactus@ros.com.sg<br> +65 67788271</p>
                <p>hi@ros.com.sg</p>
            </div>
            <div class="col-lg-4 copyright show ">
                <a href="#/home "><img src="./assets/img/ros_logo.png " alt=" "></a>

                <p>© 2019 Rotating Offshore Solutions Pte Ltd.</p>
            </div>
        </div> -->
    </div>
</footer>